<div class="blocked-wrapper blocked-wrapper-media">
  <div class="blocked">
    <mm-icon class="blocked__icon" name="lock"> </mm-icon>
      <span class="blocked__title">{{ trans.title | translate }}</span>
      <span class="blocked__message">
        {{ trans.message | translate }}</span
      >
      <button
        mm-button
        class="blocked__action"
        color="primary"
        size="large"
        (click)="redirectToHelp()"
      >
        {{ trans.label | translate }}
      </button>
  </div>
</div>
